export const roles = {
    ADMIN: "ADMIN",
    CONTENT: "CONTENT",
    WORKER: "WORKER",
    CUSTOMER: "CUSTOMER",
    TEST: "TEST",
    GUEST: "GUEST",
    PARTNER: "PARTNER",
    PREMIUM: "PREMIUM"
};
